<template>
  <div class="navigation-container">
    <v-btn
      class="zamg-text-label ml-4 zamg-button"
      variant="text"
      elevation="0"
      data-testid="stepper-abort"
      :disabled="hideAbort"
      @click="emitAbort"
    >
      {{ t('abort') }}
    </v-btn>
    <v-btn
      class="zamg-text-label ml-4 zamg-button"
      variant="text"
      elevation="0"
      data-testid="stepper-previous"
      :disabled="hidePrevious"
      @click="emitPrevious"
    >
      {{ t('previous') }}
    </v-btn>
    <v-btn
      class="zamg-text-label ml-4 zamg-button"
      variant="text"
      elevation="0"
      data-testid="stepper-next"
      :disabled="!allowNext || hideNext"
      @click="emitNext"
    >
      {{ t('next') }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n";

export default defineComponent ({
  name: 'StepperNavigation',
  components: {},
  props: {
    hideAbort: { type: Boolean, default: false},
    hidePrevious: { type: Boolean, default: false},
    hideNext: { type: Boolean, default: false},
    allowNext: { type: Boolean, default: false},
  },
  emits: ['abort', 'previous', 'next'],
  setup(_, { emit }) {
    const { t } = useI18n();

    function emitAbort() {
      emit('abort');
    }

    function emitPrevious() {
      emit('previous');
    }

    function emitNext() {
      emit('next');
    }

    return {
      t,
      emitAbort,
      emitPrevious,
      emitNext,
    };
  }, 
})
</script>

<style scoped>
.navigation-container {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 48px;
  z-index: 7;
  background-color: rgb(var(--v-theme-background));
  margin: 8px 16px 16px 16px;
}
</style>
